const MAX_STAKEHOLDERS = 4;
const SSN_LENGTH = 9;

export { MAX_STAKEHOLDERS, SSN_LENGTH };
